<template>
  <div class="content">
    <h2>Business Loan Application</h2>
    <hr />
    <h4>Company Information</h4>
    <div class="columns">
      <div class="column is-half">
        <div class="field">
          <label class="label">Business Legal Name</label>
          <div class="control">
            <input
              :value="getVal('business', 'name')"
              class="input"
              type="text"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">Federal Tax ID</label>
          <div class="control">
            <input
              :value="getVal('business', 'fein')"
              class="input"
              type="text"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">Business Start Date</label>
          <div class="control">
            <input
              :value="getVal('business', 'startdate')"
              class="input"
              type="text"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">Type of Business</label>
          <div class="control">
            <input
              :value="getVal('business', 'classification')"
              class="input"
              type="text"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">Industry</label>
          <div class="control">
            <input
              :value="getVal('business', 'industry')"
              class="input"
              type="text"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">Main Phone</label>
          <div class="control">
            <input :value="getVal('pg', 'mobile')" class="input" type="text" />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">Organization State</label>
          <div class="control">
            <input
              :value="getVal('business', 'state')"
              class="input"
              type="text"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">Desired Loan Amount</label>
          <div class="control">
            <input
              :value="
                '$' +
                numberWithCommas(getVal('business', 'requestedAmount'), true)
              "
              class="input"
              type="text"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">Gross Monthly Sales</label>
          <div class="control">
            <input
              :value="
                '$' + numberWithCommas(getVal('business', 'monhtlySales'), true)
              "
              class="input"
              type="text"
            />
          </div>
        </div>
      </div>
      <div class="column is-half">
        <div class="field">
          <label class="label">Business Website</label>
          <div class="control">
            <input
              :value="getVal('business', 'website')"
              class="input"
              type="text"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">Use of Proceeds</label>
          <div class="control">
            <input
              :value="getVal('loan', 'justification')"
              class="input"
              type="text"
            />
          </div>
        </div>
      </div>
    </div> -->

    <div class="columns">
      <div class="column is-two-fifths">
        <div class="field">
          <label class="label">Business Physical Address</label>
          <div class="control">
            <input
              :value="getVal('business', 'address')"
              class="input"
              type="text"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">City</label>
          <div class="control">
            <input
              :value="getVal('business', 'city')"
              class="input"
              type="text"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">State</label>
          <div class="control">
            <input
              :value="getVal('business', 'state')"
              class="input"
              type="text"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">Zip</label>
          <div class="control">
            <input
              :value="getVal('business', 'zip')"
              class="input"
              type="text"
            />
          </div>
        </div>
      </div>
    </div>

    <hr />
    <h4>Owner/Officer Information</h4>
    <div
      v-if="blaData.additional_signers && blaData.additional_signers.length > 0"
    >
      <div
        v-for="(signer, idx) in blaData.additional_signers"
        v-bind:key="'signer' + idx"
      >
        <div class="columns">
          <div class="column">
            <div class="field">
              <label class="label">First Name</label>
              <div class="control">
                <input :value="signer.fn" class="input" type="text" />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">Last Name</label>
              <div class="control">
                <input :value="signer.ln" class="input" type="text" />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">Title</label>
              <div class="control">
                <input :value="signer.title" class="input" type="text" />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">Ownership %</label>
              <div class="control">
                <input :value="signer.ownership" class="input" type="text" />
              </div>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <div class="field">
              <label class="label">Social Security #</label>
              <div class="control">
                <input :value="signer.ssn" class="input" type="text" />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">Date of Birth</label>
              <div class="control">
                <input :value="signer.dob" class="input" type="text" />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">Mobile Phone</label>
              <div class="control">
                <input :value="signer.mobile" class="input" type="text" />
              </div>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column is-two-fifths">
            <div class="field">
              <label class="label">Home Street Address</label>
              <div class="control">
                <input :value="signer.address" class="input" type="text" />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">City</label>
              <div class="control">
                <input :value="signer.city" class="input" type="text" />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">State</label>
              <div class="control">
                <input :value="signer.state" class="input" type="text" />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">Zip</label>
              <div class="control">
                <input :value="signer.zip" class="input" type="text" />
              </div>
            </div>
          </div>
        </div>
        <hr />
      </div>
    </div>
    <div v-else>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">First Name</label>
            <div class="control">
              <input :value="getVal('pg', 'fn')" class="input" type="text" />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">Last Name</label>
            <div class="control">
              <input :value="getVal('pg', 'ln')" class="input" type="text" />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">Title</label>
            <div class="control">
              <input :value="getVal('pg', 'title')" class="input" type="text" />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">Ownership %</label>
            <div class="control">
              <input
                :value="getVal('pg', 'ownership')"
                class="input"
                type="text"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">Social Security #</label>
            <div class="control">
              <input :value="getVal('pg', 'ssn')" class="input" type="text" />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">Date of Birth</label>
            <div class="control">
              <input :value="getVal('pg', 'dob')" class="input" type="text" />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">Mobile Phone</label>
            <div class="control">
              <input
                :value="getVal('pg', 'mobile')"
                class="input"
                type="text"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column is-two-fifths">
          <div class="field">
            <label class="label">Home Street Address</label>
            <div class="control">
              <input
                :value="getVal('pg', 'address')"
                class="input"
                type="text"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">City</label>
            <div class="control">
              <input :value="getVal('pg', 'city')" class="input" type="text" />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">State</label>
            <div class="control">
              <input :value="getVal('pg', 'state')" class="input" type="text" />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">Zip</label>
            <div class="control">
              <input :value="getVal('pg', 'zip')" class="input" type="text" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <hr />
    <h4>Authorizations</h4>
    <p class="is-size-7">
      By signing below, each of the above listed business and business
      owner/officer (individually and collectively, “you”) authorize Cardiff,
      Inc. (“Cardiff”) and each of its representatives, successors, assigns and
      designees (“Recipients”) that may be involved with or acquire commercial
      loans having daily repayment features or purchases of future receivables
      including Merchant Cash Advance transactions, including without limitation
      the application therefor (collectively, “Transactions”) to obtain consumer
      or personal, business and investigative reports and other information
      about you, including credit card processor statements and bank statements,
      from one or more consumer reporting agencies, such as TransUnion, Experian
      and Equifax, and from other credit bureaus, banks, creditors and other
      third parties. You also authorize Cardiff to transmit this application
      form, along with any of the foregoing information obtained in connection
      with this application, to any or all of the Recipients for the foregoing
      purposes. You also consent to the release, by any creditor or financial
      institution, of any information relating to any of you, to Cardiff and to
      each of the Recipients, on its own behalf.
    </p>

    <div
      v-if="blaData.additional_signers && blaData.additional_signers.length > 0"
    >
      <div
        v-for="(signer, idx) in blaData.additional_signers"
        v-bind:key="'signature' + idx"
      >
        <div class="columns">
          <div class="column is-one-third">
            <div class="field">
              <div class="signature_container">
                <img
                  style="max-height: 95px"
                  src="../../../src/assets/img/curved_edge.png"
                />
              </div>
              <div class="signature_data">
                <label class="label">eSigned by:</label>
                <img
                  class="signature-image"
                  style="max-height: 100px"
                  :src="signer.signature"
                />
                <label class="label">{{ "IP: " + signer.ip }}</label>
              </div>
            </div>
          </div>
          <!-- <div class="column">
            <div class="field">
              <label class="label">IP</label>
              <div class="control">
                <input :value="signer.ip" class="input" type="text" />
              </div>
            </div>
          </div> -->
          <div class="column">
            <div class="field">
              <label class="label">Owner Name</label>
              <div class="control">
                <input :value="signer.fullname" class="input" type="text" />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">Date</label>
              <div class="control">
                <input :value="signer.signed" class="input" type="text" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="columns">
        <div class="column is-one-third">
          <div class="signature_container">
            <img src="../../../src/assets/img/curved_edge.png" />
          </div>
          <div class="signature_data">
            <label class="label">eSigned by:</label>
            <img
              class="signature-image"
              style="max-height: 90px"
              :src="model.pg.signature"
            />
            <label class="label">{{ "IP: " + model.pg.ip }}</label>
          </div>
        </div>
        <!-- <div class="column">
          <div class="field">
            <label class="label">IP</label>
            <div class="control">
              <input :value="model.pg.ip" class="input" type="text" />
            </div>
          </div>
        </div> -->
        <div class="column">
          <div class="field">
            <label class="label">Owner Name</label>
            <div class="control">
              <input
                :value="getVal('pg', 'fullname')"
                class="input"
                type="text"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">Date</label>
            <div class="control">
              <input
                :value="getVal('pg', 'signed')"
                class="input"
                type="text"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import Input from "@/components/shared/Input";
import moment from "moment";
export default {
  name: "BLA",
  components: {},
  props: {
    model: Object,
  },
  data() {
    return {};
  },
  computed: {
    blaData: function () {
      let r = this.model;
      console.log(r);
      return r;
    },
  },
  methods: {
    getVal(obj, key) {
      if (this.model && this.model[obj] && this.model[obj][key]) {
        // if (key == "mobile") {
        //   return "858-428-9708";
        // }
        return this.model[obj][key];
      }
      return "";
    },
    formatUnixTS(ts) {
      // console.log("formatting", ts);
      return moment.unix(ts).format("l LT");
    },
    formatUnixDate(ts) {
      // console.log("formatting", ts);
      return moment.unix(ts).format("l");
    },
    formatDate(date) {
      // console.log("formatting", ts);
      let d = moment(date, "MMDDYYYY").format("l");
      if (d == "Invalid date") {
        return "-";
      }
      return d;
    },
    numberWithCommas(val, money = true) {
      if (money) val = parseFloat(val).toFixed(2);
      var returnval = null;
      if (val != null)
        returnval = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      if (returnval == "NaN") returnval = "0.00";

      return returnval;
    },
    next() {
      this.$emit("next", this.$data);
      console.log(this.$data);
    },
    prev() {
      this.loading = true;
      this.$emit("prev", this.$data);
    },
    scrollY() {
      this.scroll = window.top.scrollY;
      // console.log(this.scroll)
    },
  },
  mounted: function () {
    window.addEventListener("scroll", this.scrollY);
  },
  beforeDestroy: function () {
    window.removeEventListener("scroll", this.scrollY);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header-floating {
  top: 0px;
  transform: scale(0.9) translateY(80px);
  box-shadow: 0px 4px 19px -8px #cbc1c1;
  width: 100%;
}
.header-floating-open {
  top: -15px;
  transform: scale(0.9) translateY(90px);
  box-shadow: 0px 4px 19px -8px #cbc1c1;
  width: 100%;
}
.floating {
  top: 0px;
  transform: translateY(0px) translateX(-10px);
  box-shadow: 0px 4px 19px 0px #cbc1c1;
  width: 100%;
}
.incomplete-row {
  background: #ececec;
  opacity: 0.3;
}
.title-cell {
  /* background: #f0f0f0; */
  background: #f8fbff;
  text-align: right;
}
.creditor {
  padding: 10px;
}
.title-name {
  font-size: 1.2rem;
  margin-top: 0px !important;
  font-weight: 400;
}
.columns {
  margin-bottom: 0px;
}
.signature_container {
  display: inline-block;
  width: 37px;
  height: 112px;
}
.signature_data {
  display: inline-block;
  width: 230px;
}
.signature-image {
  position: relative;
  left: -20px;
}
</style>
